query PollsList($search: String, $page: Int, $rowsPerPage: Int) {
  polls(search: $search, page: $page, rowsPerPage: $rowsPerPage) {
    count
    nodes {
      id
      question
      options {
        id
        text
        isCorrect
      }
      isMultiple
      resultsMode
      usage {
        attachmentsCount
        isLocked
      }
      createdAt
    }
  }
}
